import React, { useState, useEffect, useRef } from "react";
import { Container, Row, Col } from "react-bootstrap";
// import {  useParams } from "react-router-dom";
import "./index.scss";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { getActivityListByWorkFlowID } from "api/activity";
import { resetActivityListState, setupdateStartValue } from "redux/activityListReducer";
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
const Activity = () => {
  // const params = useParams();
  const params = useSelector((state) => state?.urlEncryption?.urlParams);
  const dispatch = useDispatch();

  const timeDifference = (pastDate) => {
    const currentDate = new Date();
    let date = new Date(pastDate);

    const difference = currentDate.getTime() - date.getTime();
    const minutes = Math.floor(difference / 60000);
    const hours = Math.floor(minutes / 60);

    if (minutes < 1) {
      return "just now";
    } else if (minutes < 60) {
      return `${minutes} minutes ago`;
    } else if (hours < 24) {
      return `${hours} ${hours === 1 ? "hour" : "hours"} ago`;
    } else {
      return moment(date).format("DD MMM YYYY [at] hh:mm A"); // '12 feb 2020 at 3:00 pm'
    }
  };

  const workFlow_id = params?.primaryWorkflowId;

  const activityList = useSelector(
    (state) => state?.activityListReducer?.activityList
  );
  const start = useSelector((state) => state?.activityListReducer?.start);
  const limit = useSelector((state) => state?.activityListReducer?.limit);
  const totalActivities = useSelector(
    (state) => state?.activityListReducer?.total
  );
  const [startVal, setStartVal] = useState(0);
  const updateStartValue = useSelector((state) => state?.activityListReducer?.updateStartValue);
  const sortBy = useSelector((state) => state?.activityListReducer?.sortBy);
  const sortOrder = useSelector(
    (state) => state?.activityListReducer?.sortOrder
  );
  const loadingActivities = useSelector(
    (state) => state?.activityListReducer?.loading
  );
  const [downScrollValue, setdownScrollValue] = useState(limit);
  const [key, setKey] = useState('home');

  const appendFloat = limit / 2;
  const totalActivitiesRef = useRef(totalActivities);
  const startRef = useRef(start);
  
  const {userSubworkFlowInfo} = useSelector((state) => state?.dashboardDetailReducer);
  useEffect(() => {
    startRef.current = startVal;
  }, [startVal]);
  const updateStartValueRef = useRef(updateStartValue);
  useEffect(() => {
    updateStartValueRef.current = updateStartValue;
  }, [updateStartValue]);
  useEffect(() => {
    totalActivitiesRef.current = totalActivities;
  }, [totalActivities]);
  const [activitieslist, setActivitylist] = useState([]);

  useEffect(() => {
    dispatch(resetActivityListState());

    dispatch(
      getActivityListByWorkFlowID({
        workFlow_id,
        start: 0,
        limit: 10,
        sortBy,
        sortOrder,
      })
    );
  }, []);

  useEffect(() => {
    // when the comments are fetched we will set the comments in the state
    if (activityList) {
      setActivitylist(activityList);
    }
  }, [activityList]);
  const downScrollValueRef = useRef(downScrollValue);
  // triggers when the user scrolls to the bottom of the comment list
  const handleScroll = () => {
    const updatedDownScrollValue = downScrollValueRef.current;
    const totalActivities = totalActivitiesRef.current;
    if (totalActivities <= limit) {
      return;
    }
    let newStart;
    if (updateStartValueRef.current != 0) {
      newStart = updateStartValueRef.current;
    } 
    newStart = updatedDownScrollValue;
    let difference = totalActivities - updatedDownScrollValue;
    let val = difference - limit;
    if (updatedDownScrollValue == totalActivities) {
      return;
    }
    if (val <= appendFloat) {
      dispatch(
        getActivityListByWorkFlowID({
          workFlow_id,
          start: newStart,
          limit: limit + val,
          sortBy,
          sortOrder,
        })
      );
      let newValue = updatedDownScrollValue + limit + val;
      setdownScrollValue(newValue);
      downScrollValueRef.current = newValue;
      if (newValue == totalActivities) {
        return;
      }
    } else {
      downScroll();
    }
  };
  const downScroll = () => {
   const totalActivities = totalActivitiesRef.current;
    const updatedDownScrollValue = downScrollValueRef.current;
    let newStart;
    newStart = startRef.current + limit;
    dispatch(
      getActivityListByWorkFlowID({
        workFlow_id,
        start: newStart,
        limit: limit,
        sortBy,
        sortOrder,
      })
    );
    let newValue = updatedDownScrollValue + limit;
    dispatch(setupdateStartValue(newValue));
    setdownScrollValue(newValue);
    downScrollValueRef.current = newValue;
    setStartVal(newStart);
    startRef.current = newStart;
    if (newValue == totalActivities) {
      return ;
    }
  };

  // const handleScrollUp = (e) => {
  //   console.log("functionup called");
  // };

  const removeHTMLTAggs = (str) => {
    if (str === null || str === "") return false;
    else str = str.toString();
    return str.replace(/<[^>]*>/g, "");
    
  };

  const getRemarksAndActivity = (str)=>{
    let input = removeHTMLTAggs(str);
    let remarks,activity;
    remarks = input.includes('Remarks') ? input.slice(input.indexOf("Remarks"),input.length) : '';
    [activity,] = input.split('Remarks');
    return [activity,remarks]
  }

  const getProfileName = (firstName) => {
    let profileName = firstName?.split(' ')?.filter(item => item != '') || ''
    // console.log(profileName);
    // const firstletter =
    //   firstName?.length && firstName.split(" ")[0]
    //     ? firstName.split(" ")[0].slice(0, 1).toUpperCase()
    //     : // else take the first letter of the name and make it uppercase
    //     firstName?.length
    //     ? firstName.slice(0, 1).toUpperCase()
    //     : "";
    // const lastLetter =
    //   // first check if there is a space in the name then split the name else return nothing
    //   firstName?.length && firstName.split(" ")[1]
    //     ? firstName.split(" ")[1].slice(0, 1).toUpperCase()
    //     : // else take the second letter of the name and make it uppercase
    //     firstName?.length
    //     ? firstName.slice(1, 2).toUpperCase()
    //     : "";
    // const firstLetter = profileName[0].slice(0,1).toUpperCase()
    // const lastLetter = profileName[profileName.length - 1].slice(0,1).toUpperCase()
    const firstLetter = profileName[0]?.slice(0,1)?.toUpperCase()
    let lastLetter=''
    if(profileName.length>1){
      lastLetter = profileName[profileName?.length - 1]?.slice(0,1)?.toUpperCase()
    }
    return (
      <p className="profile_name pt-1 h-30px w-30px d-flex align-items-center justify-content-center rounded-circle fs-13px">
        {firstLetter ? firstLetter : ""}
        {lastLetter ? lastLetter : ""}
      </p>
    );
  };


    useEffect(() => {
      const container = document.querySelector(".activity-container-height");
      // if (container) {
      //   const hasVerticalScroll = container.scrollHeight > container.clientHeight;
      //   if (!hasVerticalScroll) {
      //     dispatch(
      //       getActivityListByWorkFlowID({
      //         workFlow_id,
      //         start: 0,
      //         limit: 20,
      //         sortBy,
      //         sortOrder,
      //       })
      //     );
      //   }
        container.addEventListener("scroll", (e) => {
          // detect the scroll at the bottom of the container
          const endOfScroll = (e.target.scrollHeight - e.target.scrollTop ) - 1 === e.target.clientHeight;       
          // const endOfScroll = e.target.scrollTop + e.target.offsetHeight > e.target.scrollHeight
          // detect the scroll at the top of the container
          const topOfScroll = e.target.scrollTop === 0;

          if (endOfScroll) {
            handleScroll();
          }
          // if(topOfScroll){
          //   handleScrollUp()
          // }
        });
      // }
    }, []);

  return (
      <>
          <Row className="activity-animation">
              <Col md={12} lg={12} >
                  <div className="activity-container-height overflow-auto theme-scrollbar"
                  onScroll={()=> handleScroll}>
                      {/* <p className=".activity_title m-0 fs-15px text-theme fw-bold border-blue-theme-bottom border-bottom py-2 border-2">
                          Activity
                      </p> */}
                      {/* { totalActivities > 0 &&
                        <div className="ms-2 mb-2 h-20px w-20px  d-flex align-items-center justify-content-center text-white bg-danger rounded-circle">
                          <p className=".activity_count m-0 fs-12px h-15px">
                              {totalActivities}
                          </p>
                      </div> 
                      } */}
                      <Tabs
                        id="controlled-tab-example"
                        activeKey={key}
                        onSelect={(k) => setKey(k)}
                        className="mt-2  detail-nav-tabs border-2 border-transparent pb-3 nav nav-tabs"
                      >
                        <Tab eventKey="home" title="Activity">
                        {activitieslist && activitieslist?.length
                          ? activitieslist.map((activity, index,arr) => {
                                return (
                                  <>
                              
                                    
                                    <div className={`d-flex align-items-center align-items-lg-start align border-bottom border-light border-2 mt-2 pb-2`}>
                                      <div className="me-2">
                                      <div className="profile_image d-flex justify-content-center">
                                                    {getProfileName(
                                                        activity?.user_name
                                                    )}
                                                </div>
                                      </div>
                                      <div className="px-2">
                                      <div className="activity_card_message break-work-when-exceeds">
                                                    {activity.body &&
                                                        getRemarksAndActivity(activity.body)[0]
                                                    }
                                                </div>
                                                <p className="m-0 fs-12px text-theme break-work-when-exceeds">
                                                { activity.body &&
                                                  getRemarksAndActivity(activity.body)[1]
                                                }
                                                </p>
                                                <div className="time">
                                                    {timeDifference(
                                                        activity.created_at
                                                    )}
                                                </div>
                                      </div>
                                    </div>
                                    </>
                                );
                            })
                          : null}
                        </Tab>

              <Tab eventKey="profile" title="Change requests">
              <Container>
                    {userSubworkFlowInfo?.updateRequested && 
                      userSubworkFlowInfo?.updateRequested.slice() 
                        .sort((a, b) => new Date(b.updateRequestedAt) - new Date(a.updateRequestedAt)) 
                        .map((item, i) => item.requestedFlow != "edit" && (
                          <React.Fragment key={i
                      }>
                            <Row className="d-flex justify-content-center align-items-center">
                              <Col lg={
                          2
                      } className="pe-0">
                                {getProfileName(item?.internalUserName)
                      }
                              </Col>
                              <Col lg={
                          10
                      } className="ps-0">
                                <p className="fs-12px fw-semibold mt-1">
                                  {`${item?.internalUserName
                          } has initiated to make some changes`
                      }
                                </p>
                              </Col>
                            </Row>

                            <div className="border rounded-2">
                              <div className="border-bottom px-2 py-2 d-flex justify-content-between align-items-center">
                                <div className="fs-12px fw-semibold">Account details</div>
                                <div className={`h-30px text-black rounded-pill border-1 border-solid max-w-fit-content d-flex align-items-center px-2 text-capitalize fs-12px ${item?.is_active ? 'pending-response' : 'completed'
                          }`
                      }> 
                                  {item?.is_active ? 'Pending response' : 'Completed'
                      }
                                </div>
                              </div>
                              <div className="d-flex flex-wrap gap-2 p-2 border-bottom">
                                {item.updateRequestedFields?.map((field, j) => (
                                  <div key={j
                          } className="bg-theme-grey-3 px-2 fs-12px py-1">
                                    {field?.label
                          }
                                  </div>
                                ))
                      }
                              </div>

                              <div className="d-flex justify-content-between py-2 align-items-center">
                                <div className="fs-12px ms-2 mt-1 text-grey-light-2">Reason</div>
                                <div className="border fs-12px mx-2 px-3 py-1 rounded-1 text-grey-light-2 break-work-when-exceeds">
                                  {item?.comment
                      }
                                </div>
                              </div>
                            </div>
                            <div className="border-bottom border-1 my-3"></div>
                          </React.Fragment>
                        ))
                  }
               </Container>



              </Tab>
            </Tabs>
                  </div>
              </Col>
              {/* <Col
                  md={12}
                  lg={12}
                  className="activity-container-height overflow-auto theme-scrollbar"
                  onScroll={()=> handleScroll}
              >
                  <Row >
                    
                  </Row>
              </Col> */}
          </Row>
      </>
  );
};

export default Activity;
